import { axiosClient } from "./axiosClient";

export interface ReviewFilters {
  isPublished?: string;
  isFlagged?: string;
  cursor?: string;
  limit?: number;
}

// Fetch all reviews (admin only)
export const fetchReviews = async (filters: ReviewFilters) => {
  const { data } = await axiosClient.get('/marketplace/reviews/admin/all', { params: filters });
  return data;
};

// Delete review (admin only)
export const deleteReview = async (reviewId: string, reason: string) => {
  const { data } = await axiosClient.delete(`/marketplace/reviews/admin/${reviewId}`, {
    data: { reason },
  });
  return data;
};

// Moderate review (admin only)
export const moderateReview = async (reviewId: string, action: 'approve' | 'remove', reason?: string) => {
  const { data } = await axiosClient.put(`/marketplace/reviews/${reviewId}/moderate`, {
    action,
    reason,
  });
  return data;
};
